import { render, staticRenderFns } from "./uinfo.vue?vue&type=template&id=31e87c2c&scoped=true"
import script from "./uinfo.vue?vue&type=script&lang=js"
export * from "./uinfo.vue?vue&type=script&lang=js"
import style0 from "./uinfo.vue?vue&type=style&index=0&id=31e87c2c&prod&lang=scss"
import style1 from "./uinfo.vue?vue&type=style&index=1&id=31e87c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e87c2c",
  null
  
)

export default component.exports